export const translatedTexts = {
  locale: "en_US",
  AGRILTRE: "Agriculture",
  TP_DEALER_ID: "Dealer Id",
  PLS_ENTR_VALID_HR_FRM: "Please enter a valid integer value in Hours (From)",
  MON_JUL: "JUL",
  NZT: "New Zealand Dollar (NZD)",
  USER_ID: "User Id",
  NO_SRH_RSLT_DEAL: "There are no search results for deal status as Quote",
  RETURN_MAIN_MENU: "Return to Main Menu",
  US_AVERAGE_PRICES: "US Average Prices",
  RU_KEY_ACCOUNTS: "RUSSIA KEY ACCOUNTS",
  PLS_SEL_REGION: "Please Select Region",
  ERR_MSG_TP_REF_NO_REC_EXT:
    "Deal cannot be updated since no deal record exists with this Tp Reference Number",
  LEN_GRSS_MARGN_PER_EXD:
    "Length of Gross Margin percentage exceeds its maximum limit.",
  ERR_MSG_SALE_REASON: "Sale Reason is invalid",
  WON_LOST_QUOTE: "Won/Lost/Quote",
  MON_JUN: "JUN",
  SDI: "SDI",
  PLS_ENTR_COMPET_MODEL: "Please enter name of competitive model.",
  COMPETITIVE_MANUF: "Competitive Manufacturer:",
  WARR_MTHS_COV: "Warr Mths Cov",
  SHOW_ME: "Show me...",
  EASE_OF_FINANCING: "Ease of Financing",
  SELECTED_MONTH: "Selected Month",
  FINAL_SPREAD_PERCENT: "Final Spread %",
  SEARCH: "Search",
  COMM_OTHER_SEGMENTS: "Commercial (All Other Segments)",
  DOWNLOAD_TRANS_PRIC_DAT: "Download Transaction Pricing Data",
  BOLIVIAN_BOLIVIANO: "Bolivian boliviano",
  JD_LINK: "JD Link",
  PAYMENT_METHOD: "Payment Method",
  BCK: "Back",
  PLS_ENTR_TRADE_BOOK_VAL: "Please enter Trade Book Value.",
  TP_R_VALID: "Valid",
  CUSTOM_TO: "To",
  ACCPTBLE_DAY_YR_FRMTS: "Acceptable 'day in year' formats are D, DD and DDD",
  NEW_ZEALAND_DOLLAR: "New Zealand Dollar",
  CREATED_ON: "Created On",
  SELECT_SPECS: "Select Specs",
  ERR_MSG_INVALID_DEAL_MRKT: "Market Segment is invalid",
  USERMSG_103_LONG_DESC:
    "Too many records found. Please narrow down search result.",
  EXCH_RATE: "Exchange Rate",
  SEP: "SEP",
  LOCATION: "Location",
  DRM_REF_NUMBER: "DRM Request Number",
  SPREAD_MARGIN_CALC: "Spread & Margin Calculations",
  TRADE_IN_AMOUNT: "Trade In Amount",
  DEAL_TYPE: "Deal Type",
  ERR_MSG_SPECIFY_MAKE: "Please specify manufacturer for competition data",
  ORIGINAL_EXCEP: "Original exception",
  CONVERTED: "Converted",
  TP_NEW_WELCOME_MSG_1: "Welcome to the new",
  ERR_MSG_COMP_ALRT:
    "Deals must be submitted and/or confirmed in the system - move reports out of pending status.",
  ADD_WARRANTY_DES:
    "(For Warranty Cost, Use the amount it costs your dealership for Competition Warranty)",
  TOTAL_LOSSES: "Total Losses",
  JUL: "JUL",
  RETURN_PREV_PAGE: "Return to Previous Page",
  TRADE_IN_AMT: "Trade in Amount",
  JUN: "JUN",
  LEN_FINAL_SPRD_PER_EXCD:
    "Length of Final Spread percentage exceeds its maximum limit.",
  CANCL_INPUT_RET_MN_MNU: "Cancel Input & Return to Main Menu",
  DEALER_PRICE: "Dealer Price",
  RETAIL_NOTE_DES:
    "(Must enter rates and months in all columns to calculate correctly)",
  PERCENT_APP_PURCH: "Percent applied to Purchase",
  TRANS_DT_CANT_GRTR_THN:
    "Transaction Date (From) cannot be greater than Transaction Date (To)",
  SHOW_TRANS: "Show Transactions",
  FINAL_SPRD_EXCDS: "The Final Spread exceeds",
  VAL_ENT_TRADIN_DSNT_MATCH:
    "The 3 values entered in Trade-in does not match the formula .Please validate.",
  TIMEL_QOTE_OR_NOT: "Timeliness of Quote/ Did Not Quote",
  CONTINUE: "Continue",
  USERMSG_101_SHRT_DESC: "Wrong Sales Person Id",
  PLS_ENTR_VALID_HRS_FRM: "Please enter a valid integer value in Hours (From)",
  PLS_CORCT_ERR: "Please correct the errors first!",
  TRANS_FOUND_MSG:
    "Transaction(s) found. Modify them by clicking on the customer name.",
  WON: "Won",
  MEXICAN_PESO: "Mexican peso",
  SHLD_VALD_WHOLE_NUM: "should be a valid whole number with no decimal point",
  NOT_AUTH_TO_TP: "Not authorized to access Transaction Pricing System.",
  PLS_ENT_SALE_PRIC_LEAS: "Please enter Sale Price To Leasing",
  SAVE_INPUT_RET_MAIN_MENU: "Save Input & Return to Main Menu",
  ERR_DEL_NT_SUCESFUL: "Delete unsuccessful",
  PARENT_DEALER_ACCOUNT_ID: "Parent Dealer Account ID",
  PLZ_SLC_INAVLID_ALRT: "Please select at least one alert type.",
  PIN_INVLID_ENTR_ALPH_NUM:
    "PIN is invalid. Please enter a 13 or 17 digit (alpha numeric)value.",
  COMPETATIVE_MODEL_DESC:
    "Do not include manufacturer name or other comments in this field.",
  HRS: "Hrs",
  INCLUDE_BIDS: "Include Bids",
  MON_DEC: "DEC",
  DP: "DP",
  SHLD_BE_VALID_NUM: "should be a valid number.",
  OF_THE_FIELD: "of the field.",
  N_A: "N/A",
  COUNTRY: "Country",
  NO_OF_DEALS: "No. of Deals",
  PLZ_SLCT_TRANS_FOR_PRNT:
    "Please select at least one Transaction for printing.",
  DATE_FORMAT_SHLD_BE: "The date format should be : mm/dd/yyyy",
  NO_BIDS: "No Bids",
  ADMIN: "Admin",
  DESC_MACHINE_DIFF: "Desc. of Machine Differences",
  SALES_MANAGER: "Sales Manager",
  PLS_ENT_PURCH_OPT_AMT: "Please enter Purchase Opt Amt.",
  ATTACHMENTS_LST_RSN: "Attachments",
  SHW: "Show",
  EXCHANGE_RATE: "Exchange Rate",
  CONFIRM_SUBMITTED_TRANS: "Confirm Submitted Transactions",
  FOR: "for",
  PAGE_BEING_REF_MSG:
    "This page is being refreshed. Please repeat last action after the page has been reloaded.",
  ERR_MSG_INVALID_PAY_TYPE: "Payment Type is invalid",
  CALC_SPREAD_MARGIN: "Calculate Spread & Margin",
  RUBLE: "Ruble",
  SALE_PRI_LEASING_CO: "Sale price to Leasing Co",
  ADD_WARRANTY: "Additional Warranty",
  LEN_FINAL_SPRD_EXCD: "Length of Final Spread exceeds its maximum limit.",
  DECIMAL_POINT_VALID: "value should not exceed",
  FEEDBACK: "Feedback",
  TRADE_IN_ALLOWNCE: "Trade In Allownce",
  SRCH_PRINT_TRANSACTIONS: "Search/Print/View Selected Transactions",
  UNIT_GRP_CANT_SEL: "Unit Group can't be selected.",
  TEXT_VAL_CHAR_LEN: "Textarea value can only be 250 characters in length.",
  STATE: "State/Province",
  ACCPTBLE_YR_FRMTS: "Acceptable year formats are yy and yyyy",
  DEAL_ANALYSIS_REPORT: "Deal Analysis Report",
  PLS_ENT_TRANS_DTE: "Please enter the Transaction Date.",
  COMMNTS_TRDE_INFO: "Comments & Trade Information",
  RENTAL_APPLIED: "Rental Applied",
  MON_FIN_GRTR_THN_ZERO:
    "Months Financed must be greater than zero for Retail Note payment method.",
  AVG_PRICE: "Average Price",
  CLCK_OK_VER_VAL:
    "Click OK to verfiy the value or Click CANCEL to return the default value.",
  ESY_OF_FINACIG: "Ease of Financing (Speed/Process)",
  SMART_GRADE: "Smart Grade",
  TP_DIVISION: "DIV",
  ERR_MSG_INVALID_COMP_MANF: "Please specify manufacturer for competition data",
  COLUMNS: "Columns",
  SAVE_SEARCH: "Save Search",
  SLCT_DEL_COMPET_CHK_BOX:
    "Select Delete Competitor check box on the next screen to remove Competitor(s).",
  TXNP_MAIN_MENU_MSG: "Transaction Pricing Main Menu",
  CURRENCY: "Currency",
  SRCH_PRINT_DEL_TRAN: "Search/Print/Delete Selected Transactions",
  TRANSACTION_DATE: "Transaction Date",
  PLS_SELCT_DTE_RNGE: "Please select a date range!",
  ADD_MORE_PIN: "Add More PIN Numbers",
  FOR_JD_EMP_DLRS: "For use by John Deere Employees and Dealers",
  USECASE: "useCase",
  UNKNWN: "Unknown",
  MSG_SELCT_PARENT_DLR: "Please select Parent Dealer",
  PORTUGUESE: "Portuguese",
  DISCOUNT_TYPE: "Discount Type",
  MON_SEP: "SEP",
  IMPORT_SEL_TRNS: "Import Selected Transaction",
  TOTAL_WINS: "Total Wins",
  LANGUGE: "Language",
  MSG_SAVE_ALERTS: "Save with Alerts",
  FATAL_ERROR: "FATAL ERROR: Field type",
  ATLST_ONE_OPT_BE_SEL: "Atleast one option should be selected",
  NO_DLRS_PRESENT: "No Dealers present.",
  REPORT_BUILDER: "Report Builder",
  ORDR_LOST_ERR_MSG:
    "If you were in the middle of processing an order only your last update to the order will be lost.We apologize for the inconvenience.",
  R_INVALID: "Invalid",
  TOTAL_QUOTE_ONLY: "Total Quote-Only",
  FOR_COMPETITOR: "For Competitor...",
  OCT: "OCT",
  PLS_ENTR_MON_LSE_PAY: "Please enter Monthly Lease Payment.",
  TP_DISC_PROG: "TRANSACTION PRICING - TP",
  PLS_ENT_SALE_QT_AMN: "Please enter Sale or Quote Amount",
  ACCPT_WEEK_YR_FRMTS: "Acceptable 'week in year' formats are w, ww",
  NA_TERM: "NA",
  SCORE_CARD_REPORT_TITLE: "Dealer Scorecard Report",
  USERMSG_101_SHRT_DES: "Wrong Sales Person Id",
  ADD_WARRANTY_DESC:
    "(For Warranty Cost, Use the amount it costs your dealership for Competition Warranty)",
  DLR_GR_MARGN_PER: "Dlr Gr Margin %",
  RECRD_WILL_BE_DEL: "This record will be deleted. Click OK to proceed",
  ACCPTBLE_DAY_WEEK_FRMTS: "Acceptable 'day of week in month' format is F",
  PLS_ENTR_MON_RENTD: "Please enter Months Rented.",
  ERR_MSG_ACC_INFO: "Unable to Retrive account information",
  BRND_LOYATY: "Brand Loyalty",
  MON_LEASED: "Months Leased",
  PLS_ENTR_DAY_FORMT: "Please enter day in format 0 followed by day.",
  INVALID_ALERT_DESCRPTN: "Invalid Alert Description",
  ROPS: "ROPS",
  NOT_VALID_SYMB: "This is not a valid symbol:",
  CASH_SALE: "Cash Sale",
  LEASE_PURCH_OPT: "Lease Purch Opt",
  YOU_ARE_LOGGED_IN_AS: "You are logged in as ",
  LESS_THAN: "Less than",
  PIN_NOT_PROVIDED:
    "(If PIN is not provided, Manufacturer, Category and Model must be selected)",
  PRICE_SUMMARY: "Price Summary",
  PLS_SEL_ENGINE: "Please select Engine.",
  ERR_MSG_INVALID_DEAL_TYPE: "Deal Type is invalid",
  VALID_NUMBER: "Please enter a valid Vendor Account Number",
  ASTERISK_CHR_NOT_ALWD: "Asterisk (*) character not allowed in",
  SEARCH_NOW: "Search Now",
  TP_PARENT_DEALER: "Parent Dealer",
  MAR: "MAR",
  COMPETITOR_DEALER_NAME: "Competitor Dealer Name",
  MAY: "MAY",
  BETTER_CRDT_TERMS: "Better Credit Terms/Down Payment",
  DEAL_RESULT: "Deal Result",
  ERR_MSG_INVALID_MAKE: "Make information not available",
  PLEASE_NOTIFY_ADMIN: "Please notify the administrator. Thank you.",
  TRANSACTION: "Transaction",
  ALPHA_NUMERIC: "should be alphanumeric.",
  PIN_NOT_PRVDED:
    "(If PIN is not provided, Manufacturer, Category and Model must be selected)",
  CHOOSE_MORE_FILES: "Choose More Files",
  MSG_ALERTS: "Alerts",
  ENTER_SALES_PERSON_COUNT: "Enter Sales Person Count",
  DOWNLOAD_TO_EXCEL: "Download to Excel",
  SAVE_THIS_SEARCH: "Save this Search",
  MON_RENTED: "Months Rented",
  WARR_MOS_OF_COVERAGE: "Warr Mos of Coverage",
  US_DOLLAR_VAL: "US dollar",
  ATTACHMENTS_LR: "Attachments",
  COST_OF_PARTS: "Cost of Parts",
  SRCH_TRANSACTIONS: "Search Transactions",
  PRICES: "Prices",
  Percentage: "Percentage",
  UR_CHNGS_R_NOT_SAVD:
    "Your changes are not saved. Click OK to Save changes or Cancel to Ignore changes and Proceed to Page1.",
  USD: "United States Dollar (USD)",
  USERMSG_104_SHRT_DESC: "No records found.",
  PLS_ENT_COMPET_MANUF: "Please enter the competitive manufacturer.",
  SELECT: "Select",
  FEATURES: "Features",
  CITY: "City",
  DEAL_REFERENCE: "Deal Reference",
  MON_OF_COVERAGE: "Months of Coverage",
  THREAD: "Thread",
  UNDERGROUND: "Underground",
  PIN_INVLD_ENTR_DIGT: "PIN is invalid. Please enter a 13 or 17 digit value.",
  PLS_ENTR_CUST_BUS_NME: "Please enter the customers business name.",
  EQUIP_QUOTED: "Equipment Quoted",
  RESET: "Reset",
  TXN_STATUS: "Txn Status",
  SHOW_REGION_AS: "Show Region As",
  CANCL_INPUT_RET_MAIN_MENU: "Cancel Input & Return to Main Menu",
  STATUS: "Status",
  PLS_ENT_PIN_CATGRY: "Please Enter Pin Number or Category.",
  REPORTS: "Reports",
  MDP: "MDP",
  CANADIAN_DOLLAR_VAL: "Canadian dollar",
  DAY_MON_TAG: "d' = Day In Month",
  MCHN_PRI_VAL_CUST: "Machine Price/Value to the Customer",
  PLS_ENTR_MACH_MDP: "Please enter machine MDP.",
  UR_CHNGS_NOT_SAVD:
    "Your changes are not saved. Click OK to Save changes or Cancel to Ignore changes and Proceed to Page1.",
  RENTAL_PURCH: "Rental Purchase",
  CNTRY_OF_MANUF: "Country of Manufacturer",
  SAVED_SEARCH_NAME: "Saved Search Name",
  TRANS_DATA_PG_TTLE_1: "Transaction Data Entry Page 1",
  TRANS_DATA_PG_TTLE_2: "Transaction Data Entry Page 2",
  MON_OCT: "OCT",
  ERR_MSG_COMP_ALRT_CA_2: "Competitor is",
  PLS_ENTER_VALID_DAY: "Please enter a valid day",
  ERR_MSG_COMP_ALRT_CA_1: "Deere",
  REVISE_SEARCH: "Revise Search",
  NA: "NA",
  Transaction: "Transaction",
  SPREAD_DETLS: "SPREAD DETAILS",
  ZIP_POSTALCODE: "Zip/PostalCode",
  PLZ_SLCT_TRANS_FOR_DEL:
    "Please select at least one Transaction for deleting.",
  TP_NEW_WELCOME_MSG:
    "Welcome to the new \r\nTransaction Pricing Application\r\nThe Transaction Pricing web application is used to report competitive conditions by dealers and communicate what is experienced in the respective market places.  This site is used to capture real time competitive information, allowing dealers and Deere to compare a variety of research to capture market based prices.",
  AUX_HYD: "Aux Hyd",
  COMNTS_CNT_MORE_THN: "Comments can't be more than 1000 characteres long",
  DUPLICATE_DATA_ENTRY:
    "Data already exist for the selected Parent Dealer with same Quarter and Year",
  NO: "No",
  USERMSG_107_DESC:
    "No Category information available in Transaction Pricing application for Pin.",
  MSG_NO_ALERTS: "No Alerts found.",
  SELECT_NO_ADD_WRNTY:
    "Selecting 'No Additional Warranty' would change Months of Coverage, Hours Limit and Warranty Cost to 0.\\nDo you want to continue?",
  OTHER_ADD_DLR_COST: "Other Additional Dealer Cost",
  COMPETITIVE_AVERAGE: "Competitive Average",
  RETAIL_NOTE: "Retail Note",
  TP_COMP_MODEL_NOT_FOUND:
    "User Defined Competitive Model Selected (Transaction is Valid)",
  MFR: "Mfr",
  OK: "OK",
  PLS_ENTER_MODEL: "Please Enter Model.",
  AMT_SHLD_IN_CURRNCY: "amount should be in currency format 00.00 or 00 .",
  ITM_MAKE_VLD_RPT_MSG: "Items that make a valid report",
  PLS_ENTER_MON_FORMT: "Please enter month in format 0 followed by month.",
  QUARRY_AGGREGATE_MINING: "Quarry & Aggregate/Mining",
  SELL_PRICE: "Selling Price",
  COPYRIGHT_DEERE: "Copyright Deere & Company. All rights reserved.",
  PLS_ENTR_NAME_SRCH: "Please enter name for the search.",
  MON_MAR: "MAR",
  PARENT_DEALER_NAME: "Parent Dealer Name",
  SITE_DEVELOPMENT: "Site Development",
  R12: "R12",
  ATTACH: "Attach",
  MON_MAY: "MAY",
  GENERATE_REPORT: "Generate Report",
  MEDIAN_COMPET_PRICES: "Median Competitive Prices",
  PLS_ENTER_VALID_DATE: "Please enter a valid date",
  PLS_ENT_PIN_NUM_CATGRY: "Please Enter Pin Number or Category.",
  TP_COMP_MODEL_VALID: "Competitor Model Valid",
  MSG_INFORMATION: "Information",
  UNKNOWN: "Unknown",
  BRL: "Brazilian Real (BRL)",
  PLS_ENTR_WRRNTY_COST: "Please enter Warranty Cost.",
  ROWS: "Rows",
  TP_DISC_PROGM: "TRANSACTION PRICING - TP",
  ERR_MSG_TP_REF_NUM_ADY_ET:
    "New deal can't be created since a deal record already exists with this Tp Reference Number",
  ERR_MSG_DEAL_RESULT: "Deal Result is invalid",
  BETWEEN: "Between",
  PLS_CORCT_ERR_FIRST: "Please correct the errors first!",
  COMPETITOR_MSG: "Competitor",
  ATTACHMENTS_SEARCH: "Attachments",
  FOUR_WD: "4WD",
  COST_OF_DLR_PGMS: "Cost of Dlr Pgms",
  CUSTOMERS: "Customer(s)",
  R24: "R24",
  WARR_COST: "Warr Cost",
  WORKSITE_SOLUTIONS: "WorkSight Solutions",
  COSTA_RICAN_COLON: "Costa Rican colon",
  DAY_WEEK_MON_TAG: "F' = Day Of Week In Month",
  R1: "R1",
  TOTAL_DISC_APPL: "Total Disc Appl",
  JDQuote: "JDQuote",
  TP_NEW_WELCOME_MSG2: "Transaction Pricing Application",
  PLS_ENTR_PURCH_OPT_AMT: "Please enter Purchase Opt Amt.",
  R3: "R3",
  TP_NEW_WELCOME_MSG3:
    "The Transaction Pricing web application is used to report competitive conditions by dealers and communicate what is experienced in the respective market places.  This site is used to capture real time competitive information, allowing dealers and Deere to compare a variety of research to capture market based prices.",
  ERR_SAVE_NT_SUCESFUL: "Save not successful",
  R6: "R6",
  TP_ERRORS: "Erros(s)",
  USERMSG_110_DES: "Not all PINs belong to same Engine Tier. Please validate.",
  GRT_THN_MAX_SIZE: "is greater than the max size",
  DEALER_COST: "Dealer Cost",
  SRCH_FOR_TRANS:
    "Search for transactions by selecting from the following......",
  R36: "R36",
  CHK_MODELS_MSG: "Check the Models you wish to include and click 'OK'",
  HOUR_LIMIT: "Hour Limit",
  INDEPENDENT_RENTAL: "Independent Rental Company",
  SUBMITTED: "Submitted",
  FALKLAND_ISLANDS_POUND: "Falkland Islands pound",
  WARRANTY_INFO: "Warranty Information",
  NO_ALERTS_FOUND: "No alerts found.",
  TP_SELECT_ENTER_MODEL: "PLEASE SELECT MODEL/ENTER NEW MODEL",
  PLS_SEL_PAYMENT_METHOD: "Please select your Payment Method, and submit again",
  ENTRY_DATE_RANGE: "Entry Date Range",
  LES_THN: "Less than",
  VIEW_DEL_SAVD_SEARCH: "View/Delete Saved Search Lists",
  TRADEIN: "TradeIn",
  GOVERNMENTAL: "Governmental",
  JDQUOTE: "JDQuote",
  ERR_MSG_INVALID_TXN_STS: "Status must be Confirmed, Submitted or Pending",
  TRADE_VALUE: "Trade Value",
  PLS_ENTR_VALID_HRS_TO: "Please enter a valid integer value in Hours (To)",
  SLECT_VALID_SUPP_NO: "Select a valid Supplier No.",
  ERR_MSG_INVALID_MODEL_COM: "Model for competition data is not specified",
  NO_SRCH_RSULT_DEAL_STAT:
    "There are no search results for deal status as Quote",
  PLS_SPCFY_HRS_RNGE_FRM: "Please specify Hours Range (From)",
  HARD_COPY_QUOTE: "Hard Copy of Quote",
  QUOTED: "Quoted",
  TP_WEB_APP: "Transaction Pricing Web Application",
  USERMSG_102_LONG_DESC:
    "Insufficient valid transactions.  At least 9 valid transactions are needed to return analysis results.",
  CAN_SURCHARGE: "Canadian Surcharge",
  PROGRAM_SPREAD: "Program Spread",
  WARR_HR_LIMIT: "Warr Hr Limit",
  OTHER: "Other",
  MACHINE_DESCRIPTION: "Machine Description",
  PLZ_NOTIFY_ADMIN: "Please notify the administrator. Thank you.",
  LEASE: "Lease",
  DEAL_IN_PENDING: "Deal is in pending status",
  FINAL_SPREAD: "Final Spread",
  LEASE_PYMT: "Lease Pymt",
  TO: "to",
  DURATION: "Duration",
  ACCPT_DAY_WEEK_FRMTS: "Acceptable 'day of week in month' format is F",
  GRTR_THAN: "Greater than",
  TP_AVG_MO_PER_SALES_MAN: "AVG/MO per salesman",
  USERMSG_109_DESC:
    "Not all PINs belong to same Category and Model. Please validate.",
  PLS_ENTR_TRANS_DTE: "Please enter the Transaction Date.",
  REVISE_TRANS_DATA: "Revise Transaction Data",
  COMPETITION: "Competition",
  QTY: "Qty",
  DESCRIP_ATT_SPECS: "Description of Att/Specs",
  CLK_OK_TO_DEL_COMPET:
    "Click OK to permanently delete the selected competitor(s)",
  drm_import: "DRM Import",
  CHNGS_WILL_LOST: "All Changes will be lost! Do you want to continue?",
  CHECK_MODELS_MSG: "Check the Models you wish to include and click 'OK'",
  SPREAD_MSG: "Spread",
  RU_DISCRETION_DISC: "RUSSIA DISCRETIONARY DISCOUNT",
  UPDATE_ERROR: "Error(s) Unable to update row",
  LOST_DUE_TO: "Lost Due To",
  CTRY_OF_MANF: "Country Of Manufacturer",
  PAGE: "Page",
  PLS_ENT_DLR_SALESPRSON: "Please enter the Deere dealer salespersons name.",
  PLS_SEL_VALD_BID_RESLT: "Please select a valid bid result for competition.",
  CANT_DEL_COMPET:
    "Cannot delete competitor(s) when confirming transaction. Please save input, first.",
  CA_SURCHARGE: "Canadian Surcharge",
  NAME: "Name",
  LAST: "Last",
  CHNGS_WIL_LOST: "All Changes will be lost! Do you want to continue?",
  PRIC: "Price",
  SHOWING_TRANSCTIONS:
    "Transaction(s) shown. To see all results, please select the Download to Excel link.",
  VS: "VS",
  FILE_REFERENCE: "File Reference",
  RECORDS_RETURNED: "records returned",
  QUOTE: "Quote",
  PLS_SELCT_CATGRY: "Please select a category!",
  SALE_QUOTE_AMOUNT: "Sale Quote Amount",
  MACHINE_DETAILS: "Machine Details",
  UNKNOWN_SERVER_ERROR:
    "Unknown Server Error. Please contact the server administrator.",
  BR_GOV_MUL_DISC: "BRAZIL GOVERNMENTAL MULTIPLE UNIT DISCOUNT",
  MM_DD_YYYY: "mm/dd/yyyy",
  PLS_ENTR_DLRSHIP_NAME: "Please enter the DealerShip Name.",
  FOR_JD_EMP_DLR: "For use by John Deere Employees and Dealers",
  ERR_MSG_SALPRSN_RACFID_V2:
    "Salesperson is mandatory, it may contain special characters or not specified",
  CREATE_SEARCH: "Create Search",
  COMPETITOR_IS_D_H_T: "Competitor is Deere",
  DEALER_STATE: "Dealer State",
  SALE_QUOTE_AMT: "Sale/Quote Amount",
  SHOW: "Show",
  CALCULATE_SPREAD: "Calculate Spread",
  NO_TRN_FOND_FR_SEL_CRT: "No transactions found for selected criteria",
  PLS_ENTER_VALD_MON: "Please enter a valid month",
  DENIED_CREDIT: "Denied Credit",
  DLR_DEAL_KEY: "DLR DEAL KEY",
  ACCPTBLE_WEEK_YR_FRMTS: "Acceptable 'week in year' formats are w, ww",
  SELLING_PRICE: "Selling Price",
  TP_PERCENT_WIN: "% of Wins",
  HOURS: "Hours",
  HOURS_RANGE: "Hours Range",
  PLS_ENTER_ENGINE: "Please Enter Engine.",
  DRM_REQUEST_NUMBER: "DRM Request Number",
  TP_WEB_APPLICATION: "Transaction Pricing Web Application",
  DEERE_DISC_APP: "Deere Discount Applied",
  RU_TARGET_ACC: "RUSSIA TARGET ACCOUNTS",
  SALES_TERR: "Sales Territory",
  ACCPTBLE_WEEK_MON_FRMTS: "Acceptable 'week in month' formats are W, WW",
  PLS_ENTER_DAY_FORMT: "Please enter day in format 0 followed by day.",
  PRIOR_TO_SALE: "(Prior to sale)",
  SEARCH_FOR_TRANS:
    "Search for transactions by selecting from the following......",
  BIDS: "bids.",
  ACTUAL_MON_REN_RATE: "Actual Monthly Rental Rate",
  ARE_U_SURE_TO_DEL_TRAN:
    "Are you sure you want to delete selected Transaction(s)?",
  DATE_VALIDATION_MSG: "The date selected is more than 90 days or 60 days in the past or future. Is this correct?",
  DEALER_LOC: "Dealer Location",
  ERR_MSG_DEAL_ALRDY_EXISTS:
    "New deal can''t be created since a deal record already exists with this Deal Key",
  TRANSACTION_FOUND_WITH: "Transaction(s) found with",
  NO_COMPETITOR_IN_DEAL: "No Competitor in deal",
  PLS_ENTR_SALE_PRICE_LEAS: "Please enter Sale Price To Leasing",
  PLS_INDCT_RES_OF_DEA:
    "Please indicate the result of this deal (Won, Lost, or Quote).",
  RN_CASH_DOWN: "RN Cash Down",
  FIELD: "field",
  ATTACH_MAX_LENGTH: "File Name is more than",
  EXCD_MAX_LEN: "exceeds its maximum length.",
  USERMSG_106_DESC: "Search does not exist.",
  EQUIP_PROM_N_FEAT: "Equipment Performance and Features",
  HARD_COPY_AVLBLE: "Hard Copy Available",
  OUTSTANDING: "outstanding",
  CNF_TRANS_DATA: "Confirm Transaction Data",
  RECVD_EXCEP_WITH_MESSG: "Received Exception with Message",
  CAN_NOT_CAL:
    "can not be calculated and will be set to 0.0 since complete information is not available. Please click on Help link to determine the values you need to enter for these calculations.",
  DO_YOU_WISH_SUBMIT: "Do you wish to submit anyway?",
  RENT_PURCH_OPT: "Rent Purch Opt",
  ENTER_SP_COUNT: "Enter Sales Person Count",
  SHOW_US_REGION_AS: "Show US Region As",
  OVR: "Over",
  LEASED_PRICE: "Leased Price",
  SPECS: "Specs",
  CHECK_COUNTRIES_MSG: "Check the Countries you wish to include and click 'OK'",
  LANDSCAPING_TP: "Landscaping",
  COPYRGHT_DEERE: "Copyright Deere & Company. All rights reserved.",
  CLOSEST_SPREAD: "Closest Spread",
  COMPETITIVE_BIDS: "Competitive Bids",
  TP_SIM_USER: "Simulate User",
  PLS_ENTR_MODEL: "Please Enter Model.",
  MACHINE_SPREAD: "Machine Spread",
  PERCENTAGE: "Percentage",
  PLS_SEL_MARKET: "Please select Market.",
  SAVE_INPUT_RET_MAIN_MNU: "Save Input & Return to Main Menu",
  PLS_ENTR_VALID_CATGRY: "Please enter a valid category",
  AUSTRALIAN_DOLLAR: "Australian Dollar",
  DEALERSHIP_REPORTS: "Dealership Reports",
  PROD_QULTY: "Product Quality",
  DATA_SAVE_SUCCESS: "Save Success",
  PLS_ENTER_VALID_DTE: "Please enter a valid date",
  LANDSCAPING: "Landscaping",
  CONTACT: "Contact",
  PRE_SDI: "PreSDI",
  ENTER_NEW_TRANS: "Enter New Transaction",
  TEXTAREA_VAL_CHAR_LEN: "Textarea value can only be 250 characters in length.",
  SALESPERSON_ID: "Salesperson ID",
  CONFIRM_TRANS: "Confirm Transaction",
  FINAL_SPREAD_IS_OVER: "Final Spread is over +/-30%",
  TP_LOSTVALID: "Lost Valid",
  CUSTOMER_COUNTY: "Customer County",
  MAX_MIN_AVG_AND: "Max, Min, Avg, and",
  TYPE_OF_WARRANTY: "Type of Warranty",
  DOWNLOAD_TRANSACTIONS: "Download Transactions",
  MUD: "MUD",
  COUNTY: "County",
  CREATED_BY: "Created By",
  CAB: "Cab",
  PLS_SEL_PAYMNT_METHD: "Please select your Payment Method, and submit again",
  CAD: "Canadian Dollar (CAD)",
  BR_GOV_DISC: "BRAZIL GOVERNMENTAL DISCOUNT",
  PAYLOAD_SCALES: "Payload Scales",
  SALES_DIV: "Sales Division",
  MSG_ALRTS: "Alert(s)",
  PLS_SPFY_TRAN_DT_FRM: "Please specify Transaction Date (From)",
  RESIDUAL_VALUE: "Residual Value",
  EMIS_RELATED: "Emissions Related",
  PLS_ENTR_PER_APP_PURCH: "Please enter Percnt applied to Purchase.",
  SHOW_AVERAGES: "Show Averages",
  ADJUSTED_MACHINE_PRICE: "Adjusted Machine Price",
  DEAL_INFO: "Deal Information",
  TCO: "Total Cost of Ownership (TCO)",
  FINANCE_RATE: "Finance Rate",
  CBD: "CBD",
  GREATER_THAN_ONE: "Greater Than One",
  TP_MAIN_MENU: "Txn Pricing Main Menu",
  PARAGUAYAN_GUARANI: "Paraguayan guarani",
  RETAIL_MUNY_LEASE: "Retail Note/Muny Lease",
  VALUE_OF_FEATURES: "Value of Features",
  DEALER_CITY: "Dealer City",
  PLEASE_CONTACT: "Please Contact",
  QUOTED_DEAL: "Quoted Deal (Deal must be Win or Lost)",
  R_U_SURE_TO_DEL_TRAN:
    "Are you sure you want to delete selected Transaction(s)?",
  SELECTING_NO_ADD_WRNTY:
    "Selecting 'No Additional Warranty' would change Months of Coverage, Hours Limit and Warranty Cost to 0.\\nDo you want to continue?",
  CLICK_OK_VER_VAL:
    "Click OK to verfiy the value or Click CANCEL to return the default value.",
  ATTACHMENTS: "Attachments",
  DEL_COMPET_CHK_BOX:
    "Select Delete Competitor check box on the next screen to remove Competitor(s).",
  MACHINE: "Machine",
  DAY_WEEK_TAG: "E' = Day In Week",
  PLS_ENTR_SALE_QTE_AMT:
    "Please enter Sale/Quote Amount. Sales/Quote Amount must be greater than 0",
  APP_ERROR_TIER_ONE:
    "An internal application error has occurred during the processing of your request. Please contact Tier One support. Please pass along the following information to support.",
  JDDEALER: "JD Dealer",
  SELECT_DRM_MCHN: "Select Machine to Import from DRM Transactions:",
  PLS_SEL_WON_LOST_RSN: "Please select Won/Lost Reason.",
  TXNP_MAIN_MENU: "Transaction Pricing Main Menu",
  USERMSG_102_LONG_DES:
    "Insufficient valid transactions.  At least 9 valid transactions are needed to return analysis results.",
  ERR_MSG_FINL_SPRD_PERCENT:
    "Length of Final Spread percentage exceeds its maximum limit",
  ERR_MSG_SALPRSN_RACF_ID: "Salesperson Information is invalid",
  SELECT_SPEC: "Select Spec(s)",
  PLS_ENT_PER_APP_PURC: "Please enter Percnt applied to Purchase.",
  LES_RESI_VALUE: "Lease Residual Value",
  PLS_ENTR_WARR_HR_LIMIT: "Please enter Warr: Hour Limit.",
  RESULT: "Result",
  PLS_ENTER_VALID_MON: "Please enter a valid month",
  VAL_MACHINE_DIFF: "Value of Machine Differences",
  MXN: "Mexican Peso (MXN)",
  PIN_INVLID_ENTR_DIGT: "PIN is invalid. Please enter a 13 or 17 digit value.",
  CLICK_OK_VER_NEW_VAL:
    "Click OK to verfiy the new value or Click CANCEL to return the default value",
  DEERE_SELLING_PRICE: "Deere Selling Price",
  FORESTRY_TP: "Forestry",
  DELETE_SELECTED: "Delete Selected",
  PLS_SEL_DIS_TYPE: "Please Select Discount Type",
  VALIDATE_PARENTDEALER: "Please select Parent dealer",
  CAN_NOT_BE_CAL:
    "can not be calculated and will be set to 0.0 since complete information is not available. Please click on Help link to determine the values you need to enter for these calculations.",
  COST_OF_PGMS: "Cost of Pgms",
  NICARAGUAN_CORDOBA: "Nicaraguan cordoba",
  ERR_MSG_SALE_PER_UNIT: "Invalid value for Sale amount",
  ACCPT_DAY_YR_FRMTS: "Acceptable 'day in year' formats are D, DD and DDD",
  ADJ_MACHINE_PRICE: "Adj. Machine Price",
  HRS_PRIOR_TO_SALE: "Hours (Prior to Sale)",
  MUST_BE_NUMERIC: "must be numeric",
  ENTER_REVIEW: "Enter and Review",
  SPREAD_PROG: "Spread on Programs",
  VALIDATE_SALESPERSONCOUNT: "Please enter Sales Person Count",
  OVERALLOWANCE: "Overallowance",
  PLS_ENTR_ENGINE: "Please Enter Engine",
  VALIDATE_YEAR: "Please select Year",
  ACCPT_YR_FRMTS: "Acceptable year formats are yy and yyyy",
  JD_DEALER: "John Deere Dealer",
  MIN_PRICE: "Min Price",
  CLOSEST: "Closest",
  WSDL: "WSDL",
  WEB_SERVICE: "Web Service",
  REVIW: "Review",
  LEN_FINL_SPRD_PER_EXCD:
    "Length of Final Spread percentage exceeds its maximum limit.",
  R_AVG_PER_SALESMAN: "R12 Avg/Mo per Salesman",
  ACCPT_DAY_MON_FRMTS: "Acceptable 'day in month' formats are d and dd",
  GET_REPORT: "Get Report",
  AMT_SHLD_IN_CURNCY: "amount should be in currency format 00.00 or 00 .",
  MON_FIN_GRT_THN_ZERO:
    "Months Financed must be greater than zero for Retail Note payment method.",
  ACCOUNT_DETAILS_SIMULATE_: "Account Details/Simulate User",

  SAVE_CREATED_SEARCH: "Save Created Search",
  SEARCH_DRM_TRANS_TITLE: "DRM Search/Import",
  BELIZE_DOLLAR: "Belize dollar",
  ENGINE: "Engine",
  APPROX_HRS_PRIOR_SALE: "Approx. Hours (Prior to Sale)",
  TRADE_IN: "Trade In",
  GOV: "GOV",
  SELECT_MODEL: "Select Model",
  CHNGS_NT_SAVD_PRNT_TRAN:
    "Your changes are not saved. Click OK to Save changes or Cancel to Ignore changes and Print the transaction.",
  WARRANTY: "Warranty",
  ADJUSTED_MACHINE_PRIC: "Adjusted Machine Price",
  CANCEL: "Cancel",
  COMPET_ANALYSIS_REPORT: "Competitive Analysis Report",
  FEATURES_VALUE: "Features Value",
  VALIDATE_DELETE: "At least one row should be selected to delete",
  GOVERNMENT: "Government",
  PIN_S: "PIN(s)",
  PLS_ENT_VALD_HRS_TO: "Please enter a valid integer value in Hours (To)",
  WEEK_YEAR_TAG: "w' = Week In Year",
  ACT_MTHLY_RENTAL: "Act Mthly Rental",
  BOOK_VALUE: "Book Value",
  USERMSG_105_DES: "PIN information not found.",
  DLR_REP_GROSS_MARGIN: "Dealer Reported Gross Margin",
  TYPE_WARRANTY: "Type of Warranty",
  DESCP_OF_FEATURES: "Description of Features",
  UNKNOWN_SERVER_ERR:
    "Unknown Server Error. Please contact the server administrator.",
  APPLIED_TO_PURCHASE: "% applied to Purchase",
  SUBMIT_REVISIONS: "Submit revisions",
  SPREAD_MACHINE: "Spread on Machine",
  TP_R_TOTAL: "Total",
  REPORTED_LR_MARGIN: "Reported Dealer Margin",
  PLS_INDCAT_MTHD_PAY: "Please indicate method of payment.",
  OK_TO_DEL_COMPET: "Click OK to permanently delete the selected competitor(s)",
  GET_SPECS: "Get Specs",
  RENT_MONTHS: "Rent Months",
  FILE_UPLOAD: "File Upload",
  UPLOAD_FILE: "Upload File",
  SALESPERSON: "Salesperson",
  MON_RENTAL_PAY: "Monthly Rental Payment",
  CLCK_OK_VER_NEW_VAL:
    "Click OK to verfiy the new value or Click CANCEL to return the default value",
  PLS_ENT_COMPET_MODEL: "Please enter name of competitive model.",
  PLS_ENT_MON_LSE: "Please enter Months Leased.",
  TEST: "Test",
  REVIEW: "Review",
  USERMSG_103_SHRT_DESC: "Too many records found.",
  RELATIONSHIP: "Relationship",
  TXN_ENTRY_DATE: "Transaction Creation Date",
  PLS_ENT_MON_FORMT: "Please enter month in format 0 followed by month.",
  BETTER_FIN_RATE: "Better Finance Rates",
  PLS_ENTR_VALID_INT: "Please enter a valid Integer",
  TP_ALERTS: "Alert",
  COMPETITOR: "Competitor",
  TP_REPORTS: "Reports",
  USERMSG_101_LONG_DESC: "Sales Person Id is incorrect.",
  Attachments: "Attachments",
  PLZ_SPCFY_HR_RNGE_FRM: "Please specify Hours Range (From)",
  LEN_NORM_TP_EXCD:
    "Length of Normalized Transaction Price exceeds its maximum limit.",
  DEALER_AVERAGES: "Dealer Averages",
  HIGH_BUY_BCK_CONT: "Higher Buy Back Contract",
  SURINAMESE_DOLLAR: "Surinamese dollar",
  PLS_SPCFY_TRANS_DT_TO: "Please specify Transaction To (To)",
  DEL_COMPETITOR_MSG: "Delete Competitor(s) ?",
  MACHINE_SPECS: "Machine Specs",
  JD_CON_FOREST_DLR_NET: "John Deere Construction & Forestry Dealer Net",
  COMPET_DEALER: "Competitive Dealer",
  DRM_IMPORT: "DRM Import",
  DEALER_NAME: "Dealer Name",
  RUSSIAN: "Russian",
  OVER: "Over",
  THIRTEEN_DIGIT_PIN: "13-Digit Pin(s):",
  DEERE_DP: "Deere DP",
  ERROR_GENERATING_RPT: "No sales person count.",
  DOWNLD_TO_EXCEL: "Download to Excel",
  ATTACHMENTS_DROP_DOWN: "Attachments Available",
  BACK: "Back",
  FRM_DTE_MST_BFR_TO: "The (from) date must come before the (to) date.",
  MAX_PRICE: "Max Price",
  TP_WARNINGS: "Warning(s)",
  SELECT_COUNTRIES: "Select Countries",
  SPREAD_ON_MACHINE: "Spread on Machine",
  CONFIRM_DELETE: "Confirm Delete Yes/No",
  ERR_MSG_W_L: "Deal result must be a win or loss",
  PARENT_DEALER_STATE: "Parent Dealer State/Province",
  CONFIRMED: "Confirmed",
  NOT_SUPP_FOR_FUN: "is not supported for this function",
  VALIDATE_DURATION: "Please select Duration",
  CUSTOMER: "Customer",
  WARRANTY_COST: "Warranty Cost",
  PLS_ENTR_SALE_QT_AMN: "Please enter Sale or Quote Amount",
  TP_R_PENDING: "Pending",
  LANGUAGE: "Language",
  CANNT_DEL_COMPET_MSG:
    "Cannot delete competitor(s) when confirming transaction. Please save input, first.",
  CLK_OK_VER_NEW_AMT_VAL:
    "Click OK to verfiy the new amount value or Click CANCEL to return the default value.",
  URUGUAYAN_PESO: "Uruguayan peso",
  MSG_SELECT_DURATION: "Please select Duration",
  MSG_INFO: "Information",
  TP_ROLE: "Role",
  JOHN_DEERE: "John Deere",
  REGION: "Region",
  SHOW_TRANSACTIONS: "Show Transactions",
  RETAIL_NOTE_DESC:
    "(Must enter rates and months in all columns to calculate correctly)",
  DTERANGE: "Date Range",
  PLS_ENT_SAL_QTE_AMT:
    "Please enter Sale/Quote Amount. Sales/Quote Amount must be greater than 0",
  UPDATED_BY: "Updated by",
  MCHN: "Machine",
  COMPET_COMPARISON: "Competitive Comparison",
  PATHWAYS: "Pathways",
  SAVE_INPUT: "Save Input",
  BACK_TO_ADMIN_VIEW: "Back to Admin View",
  OPT_INFO_SALES_MGR_ONL: "Optional Information (Sales Manager Only)",
  MON_LEASE_PAY: "Monthly Lease Payment",
  CHNGS_R_NT_SAVD_PRNT_TRAN:
    "Your changes are not saved. Click OK to Save changes or Cancel to Ignore changes and Print the transaction.",
  NO_SEARCH_FOUND: "No Search found.",
  PLS_SELECT_D_P: "Please select discount program",
  TP_GRAND_TOTALS: "GRAND TOTALS",
  PLS_ENT_ACT_MN_REN_RTE: "Please enter Actual Monthly Rental Rate.",
  PLS_ENTER_VALID_YR: "Please enter a valid 4 digit year between",
  TP_YEAR: "Year",
  CATEGORY: "Category",
  FORESTRY: "Forestry",
  JDC_DEN_CREDT: "JDC Denied Credit",
  PURCH_OPT_AMT: "Purchase Opt Amt.",
  HARDCOPY_AVIL: "HardCopy Available",
  ENGLISH: "English",
  ERR_MSG_SPRD_RANGE: "Transaction Pricing must be within +/- 30%",
  VALID_TAGS: "Valid Tags:",
  DWN_REVISE_TRANS_DATA: "Downloaded Revise Transaction Data",
  PIN: "PIN",
  LEN_SPRD_PROG_EXCD: "Length of Spread on Program exceeds its maximum limit.",
  PRINT_THIS_PAGE_MSG:
    "Print this page. It has information that will be useful to help resolve the problem.",
  SUBMIT_TRANSACTION: "Submit Transaction",
  INVALID_DRM_IMP_2: "is not available in Transaction Pricing.",
  INVALID_DRM_IMP_1: "This Transaction could not be completed.",
  ALL: "All",
  ALL_SPREAD_LES_THEN: "Less than",
  NO_TRN_FOUND_FR_SEL_CRT: "No transactions found for selected criteria",
  ACCOUNT_ID: "Account ID",
  SCORECARD: "Scorecard",
  OTHR: "Other",
  VALUE: "Value",
  ATTACH_MSG: "To include attachment, click",
  PLZ_SLC_TRANS_FOR_DEL: "Please select at least one Transaction for deleting.",
  BR_MUL_UNIT_DISC: "BRAZIL MULTIPLE UNIT DISCOUNT",
  FRM_DTE_MST_CM_BFR_TO: "The (from) date must come before the (to) date.",
  SELECT_TRADE_IN: "Select Trade In to include in this Transaction:",
  ACCPT_WEEK_MON_FRMTS: "Acceptable 'week in month' formats are W, WW",
  BR_CPRT_BSINES_DISC: "BRAZIL CORPORATE BUSINESS DISCOUNT",
  PLS_INDCAT_RES_OF_DEAL:
    "Please indicate the result of this deal (Won, Lost, or Quote).",
  BUILDING_RESIDENTIAL: "Building - Residential",
  ERR_MSG_COMP_MDL_ALERT:
    "Competitor Model is not a valid competitor model in the system.",
  JD_CONST_FOREST_DLR_NET: "John Deere Construction & Forestry Dealer Net",
  ACCPTBLE_DAY_MON_FRMTS: "Acceptable 'day in month' formats are d and dd",
  DEERE_MDP: "Deere MDP",
  EUR: "Euro (EUR)",
  PRICE: "Price",
  WEEK_MON_TAG: "W' = Week In Month",
  MON_COVERAGE: "Months of Coverage",
  US_REGION: "US Region",
  SALESPERSON_NAME: "Salesperson Name",
  CREATE_DATE: "Create Date",
  FUTURE_RESALE_VALUE: "Future Resale Value",
  WARR_TYPE: "Warr Type",
  PLS_ENT_MON_RENTD: "Please enter Months Rented.",
  AND: "AND",
  ERR_MSG_FINL_SPRD_LEN_LMT: "Length of Final Spread exceeds its maximum limit",
  SHLD_VALID_WHOLE_NUM: "should be a valid whole number with no decimal point",
  LENGTH_OF: "Length of",
  MULTI_UNIT: "Multi Unit",
  SINGLE_UNIT: "Single Unit",
  ATT_SPECS_NOT_INCL_MDP: "Att/Specs not incl in",
  LEN_LESED_PRIC_EXCD: "Length of Leased Price exceeds its maximum limit.",
  ANY: "Any",
  MAKE: "Make",
  TOTAL_RENT_RECEIVED: "Total Rent Received",
  USERMSG_110_DESC: "Not all PINs belong to same Engine Tier. Please validate.",
  MON_YEAR_TAG: "M' = Month In Year",
  DEERE_AVERAGE: "Deere Average",
  GREAT_BRITAIN_POUND: "Great Britain Pound",
  PRINT_TRANS: "Print Transaction",
  GRADE_CONTROL: "Grade Control",
  ADD_UPDATE: "Add/Update",
  DEERE_DEALER: "Deere Dealer",
  USERMSG_104_LONG_DESC: "No record(s) found.",
  IMPORT_DRM_TRANSACTIONS: "Import DRM Transaction",
  COMNTS_CANT_MORE_THN: "Comments can't be more than 1000 characteres long",
  DEALER: "Dealer",
  RECVD_EXCEP_WITH_MSG: "Received Exception with Message",
  JDCEC_MAIN_MENU: "JDCEC Main Menu",
  CUSTOMER_NAME: "Customer Name",
  CHILEAN_PESO: "Chilean peso",
  LEASE_RATE: "Lease Rate",
  JAN: "JAN",
  TAX_INCLUDED: "Tax Included?",
  PLS_SPCFY_TRANS_DT_FRM: "Please specify Transaction Date (From)",
  COMMERCIAL: "Commercial",
  DEALERSHIP_NAME: "Dealership Name",
  PLS_INDCT_MTHD_PAY: "Please indicate method of payment.",
  EXT: "Ext",
  WARR_HOUR_LIMIT: "Warr Hour Limit",
  MONTH: "Month",
  APR: "APR",
  COMPETITION_SELL_PRICE: "Competition Selling Price",
  HRS_SHLD_BE_INT: "Hours should be integer.",
  MONTHS: "Months",
  BETTER_TERMS: "Better Terms",
  ERR_MSG_TP_REF_NO_EXISTS:
    "New deal can''t be created since a deal record already exists with this TP Reference Number",
  ERR_MSG_COMP: "Competitor cannot be listed as Deere",
  VALUE_SMALL: "value",
  USERMSG_105_DESC: "PIN information not found.",
  PLS_ENTR_ACT_MON_REN_RTE: "Please enter Actual Monthly Rental Rate.",
  BID_RESULT: "Bid Result",
  USERMSG_111_LONG_DES: "Tyring to add an empty list to cache",
  PLS_ENTR_MON_LSE: "Please enter Months Leased.",
  MARKET_SEGMENT: "Market Segment",
  TP_ACC_DETAIL_LNK: "Account Details/Simulate User",
  NOT_AUTHORIZED_TO_TP: "Not authorized to access Transaction Pricing System.",
  COMPETITOR_DEALER: "Competitor Dealer",
  PLS_ENT_DLRSHIP_NAME: "Please enter the DealerShip Name.",
  INTRNAL_APP_ERR_MSG:
    "An internal application error has occurred during the processing of your request.",
  SP_COUNT_VALUE: "Maximum value of sales person",
  DLR_COST_MARGIN: "Dealer Cost and Margin",
  HONDURAN_LEMPIRA: "Honduran lempira",
  ARS: "Argentine Peso (ARS)",
  GUYANESE_DOLLAR: "Guyanese dollar",
  MON_AUG: "AUG",
  SHOW_SRCH_CRITERIA: "Show Search Criteria",
  SUBMIT_QUERY: "Submit Query",
  FIN_BUY_DOWN_COST: "Financing Buy-down Cost",
  FOR_MACHINES: "For Machines...",
  USERMSG_103_LONG_DES:
    "Too many records found. Please narrow down search result.",
  DESCRIPTION: "Description",
  PLS_SEL_VALID_BID_RESLT: "Please select a valid bid result for competition.",
  PIN_INVLID_ENT_ALPH_NUM:
    "PIN is invalid. Please enter a 13 or 17 digit (alpha numeric)value.",
  PLS_ENT_RET_FIN_DWN: "Please enter Retail Note Finance Rate.",
  QUIT_WITH_NO_REV_MADE: "Quit with no revisons made",
  RUB: "Russian Ruble (RUB)",
  MACHINE_PRI_VAL_CUST: "Machine Price/Value to the Customer",
  MON_NOV: "NOV",
  DISCOUNT_PROGRAM: "Discount Program",
  LEN_GRSS_MARGN_PER_EXCD:
    "Length of Gross Margin percentage exceeds its maximum limit.",
  TRANS_FOND_MSG:
    "Transaction(s) found. Modify them by clicking on the customer name.",
  DATERANGE: "Date Range",
  PLS_ENT_WAR_MOS_CVRGE: "Please enter Warr: Mos of Coverage.",
  PLS_ENTER_VALID_YEAR: "Please enter a valid 4 digit year between",
  ORDER_LOST_ERR_MSG:
    "If you were in the middle of processing an order only your last update to the order will be lost.We apologize for the inconvenience.",
  PLS_ENT_DLR_SALESPERSON: "Please enter the Deere dealer salespersons name.",
  BRAZILIAN_REAL: "Brazilian real",
  FREIGHT_PDI: "Freight & PDI",
  SALES_DATE_ENTRY_PERSON: "Sales Data Entry Person",
  ARGENTINE_PESO: "Argentine peso",
  QUANTITY: "Quantity",
  UPDATE_DATE: "Update Date",
  VALIDATE_QUARTER: "Please select Quarter",
  PLS_ENTR_RET_NTE_CSH_DWN: "Please enter Retail Note Cash Down.",
  YEAR_TAG: "'y' = Year",
  PLS_SEL_COUNTRY: "Please Select Country",
  AUD: "Australian Dollar (AUD)",
  BACK_TO_HOME_PAGE: "Back To Home Page",
  PARENT_DEALER_CITY: "Parent Dealer City",
  AUG: "AUG",
  COLOMBIAN_PESO: "Colombian peso",
  PRINT_THIS_PGE_MSG:
    "Print this page. It has information that will be useful to help resolve the problem.",
  BR_DISCR_DISC: "BRAZIL DISCRETIONARY DISCOUNT",
  DATE_NOT_RECOG_FORMT:
    "The date entered is not in a recognizable format or incorrect",
  FINL_SPRD_EXCDS: "The Final Spread exceeds",
  REGIONAL_AVERAGES: "Regional Averages",
  ATLST_ONE_ROW_NEDED: "At least one row is needed for Equipment information.",
  MON_JAN: "JAN",
  CONTRACT_CATEGORY: "Contract Category",
  TRANS_MONTH_YEAR: "Transaction Month/Year",
  CANADIAN_SRCHG: "Canadian Srchg %",
  MSG_SAVE_ALRTS: "Save with Alerts",
  ERR_MSG_NO_COM_MDL: "Model for competition data is not specified",
  DEALER_SUPP_AND_PAY: "Dealer Support & Response",
  MARGIN: "Margin",
  ERR_MASQUERADE_USER: "Error masquerading User",
  SAVE_INPUT_ADD_ATTACHMENT: "Save Input & Add Attachment",
  SPECIFICATIONS: "Specifications",
  CBD_SIGNATURE: "CBD Signature",
  ERR_MSG_INVALID_NO_RECORD:
    "Deal can't be updated since no deal record exists with this Deal Key",
  NORMALIZED_TP: "Normalized TP",
  NOV: "NOV",
  MON_APR: "APR",
  FEATURE: "Feature",
  PLZ_SLC_TRAN_FOR_PRNT: "Please select at least one Transaction for printing.",
  REGIONAL_PRICES: "Regional Prices",
  COMMENTS_TRADE_INFO: "COMMENTS & TRADE INFORMATION",
  MSG_SAVE_SUCCESS: "Changes were successfully saved",
  USERMSG_109_DES:
    "Not all PINs belong to same Category and Model. Please validate.",
  ERROR_MESSAGE: "Some error occured",
  YES: "Yes",
  GUATEMALAN_QUETZAL: "Guatemalan quetzal",
  TOT_DIS_APPLIED: "Total Discount Applied",
  TRADE_IN_OVER_ALLOWNCE: "Trade In Overallownce",
  FIELD_HAS_INVALID_DATA: "field has invalid data:",
  EURO: "Euro",
  LOST_SALE_DUE_TO: "Lost sale due to",
  ROAD_BUILDING: "Road Building",
  TP_DEALER_ACCOUNT: "Dealer Account",
  GROSS_MARGIN: "Gross Margin",
  VENEZUELAN_BOLIVAR: "Venezuelan bolivar",
  SALES_PERSON: "Sales Person",
  CASH_DOWN: "Cash Down",
  CREATE_NEW_SEARCH: "Create new search",
  USERMSG_102_SHRT_DESC: "Insufficient data",
  DATE_RANGE: "Date Range",
  ERR_MSG_COMP_ALRT_CA: "Competitor cannot be",
  PLS_ENTR_COMPET_MANUF: "Please enter the competitive manufacturer.",
  MACHINE_MDP: "Machine MDP",
  DATE_FORMAT_MSG: "The date format should be : mm/dd/yyyy",
  NORMALIZED_TRANS_PRICE: "Normalized Transaction Price",
  PROGRAM_USAGE:
    "Deere Program Usage (all data in this section applies to the Deere machine only)",
  TAX_RATE: "Tax Rate",
  PLZ_ENTR_VALID_DAY: "Please enter a valid day",
  RENTAL: "Rental",
  DAY_YEAR_TAG: "D' = Day In Year",
  DEL_SELECTED_TRANS: "Delete Selected Transactions",
  BUILDING_COMM_PUBLIC: "Building - Commercial, Public",
  CLEAR_ALL: "Clear All",
  DEAL_REF: "Deal Ref",
  LOST: "Lost",
  TP_ACC_DETAILS: "Account Details",
  PAGE_BENG_RFSH_MSG:
    "This page is being refreshed. Please repeat last action after the page has been reloaded.",
  TP_WON_VALID: "Won Valid",
  QUARTER: "Quarter",
  AMOUNT: "Amount",
  AVG_SPREAD: "Avg Spread",
  MON_FEB: "FEB",
  GREATER_THAN: "Greater than",
  DEAL_SOURCE: "Deal Source",
  PRINT_SELECTED_TRANS: "Print Selected Transactions",
  SUFFIX_FOR_NUM: "x' = Suffix For A Number",
  TYPE: "Type",
  PLS_ENTR_RET_NTE_FIN_DWN: "Please enter Retail Note Finance Rate.",
  SALES_PERSON_COUNT: "Sales Person Count",
  ATTACH_MAX_LENGTH2: "Please correct the",
  ATTACH_MAX_LENGTH1: "50 characters.",
  MARKET: "Market",
  AGRICULTURE: "Agriculture",
  LEN_ADJ_MACH_PRICE_EXCD:
    "Length of Adjusted Machine Price exceeds its maximum limit.",
  PLS_SEL_PROPER_DISC_PGM:
    "Selecting None in combination with other Discount Programs is not Valid. Please update your selection",
  ERR_MSG_SP_CNT_DELETE: "Unable to Delete row",
  AG_MATERIAL_HANDLING: "Ag Material handling",
  SELECT_MODELS: "Select Model(s)",
  TRANSACTION_FOUND: "Transaction(s) found.",
  MARGIN_MSG: "Margin",
  ATTACH_MAX_LENGTH3: "file name and try again.",
  REVISE_TRANS: "Revise Transaction",
  SPREAD_CALC: "Spread Calculations",
  ERR_MSG_INVALID_CATEGORY: "Category information is Invalid",
  CURRENCY_TYPE: "Currency",
  DEALERSHIP: "Dealarship",
  ARE_U_SURE_TO_DEL_SRCH:
    "Are you sure you want to delete selected Search(es) ?",
  SCORE_CARD_REPORT: "Scorecard Report",
  ENTER_USER_ID: "Enter User Id",
  ASTERISK_CHR_NOT_ALLOWD: "Asterisk (*) character not allowed in",
  SALESP_OR_CRTD_NM: "Salesperson/Created By Name",
  PURCHASE_OPT_AMT: "Purchase Opt Amt.",
  COMMENTS: "Comments",
  APPROX_HRS_PRIOR_TO_SAL: "Approx. Hours Prior to Sale",
  UNSURE: "Unsure",
  CONTACT_HLP_DESK_MSG:
    "Please contact the Help Desk using the 'Contact us' link at the top of the page to report this error.",
  NOT_SUPP_FOR_THIS_FUN: "is not supported for this function",
  PLS_ENTR_TYPE_WRRNTY: "Please enter Type of Warranty.",
  USERMSG_108_DESC: "PIN information not found.",
  PLS_ENT_PAY_AMT: "Please enter a payment amount.",
  SPREAD: "Spread",
  CHSE_SPCS_FLTR: "Choose Specs to filter search results",
  QK_CPL: "Qk Cpl",
  CUST_CLASSIFICATION: "Customer Classification",
  HELP: "Help",
  FEB: "FEB",
  OPT_INFO_SALES_MGR_ONLY: "Optional Information (Sales Manager Only)",
  MAC_AVAIL: "Machine Availability",
  TXN_ID: "Txn ID",
  NONO: "No",
  MODEL: "Model",
  NO_MODELS_FOR_COMPETITOR: "No models found for competitor",
  PENDING: "Pending",
  SRCH_PRINT_TRANS: "Search/Print/View Selected Transactions",
  MANUFACTURER: "Manufacturer",
  SPC_STATIC_MSG3: "Total includes valid and invalid reports",
  SPC_STATIC_MSG4:
    "Duration will calculate according to last day of the month selected",
  MON_FINANCED: "Months Financed",
  SPC_STATIC_MSG1: "Salesrep Count is an",
  SPC_STATIC_MSG2:
    "calculation from current, quarterly salesperson count reported for Invest for Performance (IPF)",
  ERR_MSG_NO_SPRD_CALCLATED: "Spread can not be calculated.",
  REQUIRED_FIELD: "Indicates a required field",
  MP_BKT: "MP Bkt",
  BID_ID: "BID ID",
  PLS_ENTR_TRADE_AMT: "Please enter Trade Amount.",
  USERMSG_108_DES: "PIN information not found.",
  ENTER_DRM_NUMBER: "Enter DRM Number",
  LEN_LSED_PRICE_EXCD: "Length of Leased Price exceeds its maximum limit.",
  TRADE_AMOUNT: "Trade Amount",
  US_AVERAGES: "US Averages",
  WON_SALE_DUE_TO: "Won sale due to",
  LEN_SPRD_MACH_EXCD: "Length of Spread on Machine exceeds its maximum limit.",
  RECRD_WILL_BE_DELTD: "This record will be deleted. Click OK to proceed",
  FROM: "From",
  MSG_NOALERTS: "No Alerts found.",
  TRADE_IN_BOOK_VAL: "Trade in Book value",
  DEALER_COMPETITIVE_DEALER: "Dealer/Competitive Dealer",
  DECIMAL_POINT_VALID2: "point.",
  DECIMAL_POINT_VALID1: "5 numbers before decimal",
  DIRECT_ENTRY: "Direct Entry",
  AVERAGE_SPREAD: "Average Spread",
  DID_CUSTOMER_TRADE: "Did Customer Trade?",
  CUSTOM_DATE: "Custom Date",
  MEDIAN_PRICE: "Median Price",
  JD_CONST_FOREST: "John Deere Construction & Forestry",
  LEASE_MONTHS: "Lease Months",
  ERR_MSG_MIN_COMP: "At least one competitor must be on the deal",
  CUSTOM_FROM: "From",
  VAL_ENT_TRAD_DSNT_MATCH:
    "The 3 values entered in Trade-in does not match the formula .Please validate.",
  APP_ERROR_CONT_TIER_ONE:
    "An internal application error has occurred during the processing of your request. Please contact Tier One support. Please pass along the following information to support.",
  DATE_RECOG_FORMT:
    "The date entered is not in a recognizable format or incorrect",
  TOTAL_MACHINE_QTY: "Total Machine Quantity",
  LST: "Last",
  PERUVIAN_NUEVO_SOL: "Peruvian nuevo sol",
  PAYMENT_TYPE: "Payment Type",
  DATE: "Date",
  PLS_ENT_CUST_BUS_NAME: "Please enter the customers business name.",
  ERR_GENERATE_REPORT: "Error generating report",
  MARGIN_SPREAD_MSG: "Margin & Spread",
  ERR_MSG_INVALID_MODEL: "Model information is not available",
  PLS_SLCT_ONE_SRCH_FR_DEL: "Please select at least one search for deletion.",
  TXN_MONTH_YEAR: "Txn Month/Year",
  TP_DIV: "DIVISION",
  A_C: "A/C",
  DRM_REQ_NT_FOUND:
    "DRM Request not found. Please check DRM and try your search again.",
  CALC_DLR_GRSS_MRGN: "CALC DLR GRSS MRGN",
  DEALERS: "Dealers",
  TRANSACTIONS: "Transactions",
  AVERAGE_PRICE: "Average Price",
  RN_FIN_MTHS: "RN Fin Mths",
  ATLST_ONE_ROW_NEEDED: "At least one row is needed for Equipment information.",
  COST: "Cost",
  SERVER_ERROR: "Server Error",
  PLS_ENTR_WAR_MOS_CVRGE: "Please enter Warr: Mos of Coverage.",
  CONTACT_HELP_DESK_MSG:
    "Please contact the Help Desk using the 'Contact us' link at the top of the page to report this error.",
  SP_COUNT_VALUE1: "count value should be 9999.9",
  DEALER_MENU: "Dealer Menu",
  VAL_EXCHANGE_RATE: "Currency",
  PLS_ENT_RET_CSH_DWN: "Please enter Retail Note Cash Down.",
  ATTACH_MSG1: "Browse and select the file.",
  CLCK_OK_VER_NEW_AMT_VAL:
    "Click OK to verfiy the new amount value or Click CANCEL to return the default value.",
  ATTACH_MSG2: "After you select the file",
  DEC: "DEC",
  ATTACH_MSG3: ", click Attach. The file will",
  ATTACH_MSG4: "be uploaded to",
  PLZ_ENT_MON_LSE_PAY: "Please enter Monthly Lease Payment.",
  ATTACH_MSG5: "your Transaction.",
  CHSE_SPCS_FLTR_SRCH_RSL: "Choose Specs to filter search results",
  DLR_SPONSORED_PROG_COST: "Dealer Sponsored Program Cost",
  USERMSG_107_DES:
    "No Category information available in Transaction Pricing application for Pin.",
  ERR_MSG_NO_CAT_AVAILABLE:
    "No Category information available in Transaction Pricing application",
  SPREAD_FOR: "Spread for",
  RN_FIN_RATE: "RN Fin Rate",
  MANAGE_SAVED_SEARCH: "Manage Saved Search",
  SEARCH_CRITERIA_LABEL: "Search Criteria",
  ERR_MSG_SP_CNT_DEL: "Unable to Delete row",
  DEAL_ANALYSIS_RESULT: "Deal Analysis Result",
  TXN_DATE: "Txn Date",
  NZD: "NZD",
  DLR_GR_MARGIN: "Dlr Gr Margin",
  USERMSG_111_LONG_DESC: "Tyring to add an empty list to cache",
  DELETE_COMPETITOR: "Delete Competitor",

  //NEED TO ADD IN TRANSATION API

  ACCT_SETTINGS: "Account Settings",
  DISCOUNT_PROGRAM_FIELD: "Discount Program",
  TP_ACTION: "Action",
  ADV_CRITERIA: "Advanced Criteria",
  CREATE_TRAN: "Create Transaction",
  CUSTOMER_AND_DEAL_INFO: "Customer & Deal Information",
  DLR_ACCT_ID: "Dealer Account ID",
  DELETE_FUNC: "Delete",
  ENTER_COMP_MFR: "Enter Competitor Manufacturer",
  ENTER_DLR_ACCT: "Enter Dealer Account",
  EXIT_SIMULATION_FUNC: "Exit Simulation",
  EXPORT: "Export",
  FAIL_TO_EXPORT_TRAN_MSG: "Failed To Export Transaction!",
  GEN_TRAN_RPT_WAITING_MSG: "Generating Transaction Report, Please Wait...",
  TXN_WAIT_F0R_REVIEW_MSG_1: "Hello, You Have ",
  TP_HOME: "Home",
  NODATA_FOUND_MSG: "No Data Found.",
  NO_TRANS_FOUND_MSG: "No Transactions Found.", //need to check
  REFINE_EXPORT_TXN: "Too many records... Please refine search criteria to export transaction",
  REP_DLRMRG_VALIDA_MSG: "Please enter a value in between of 0 to 30 ",
  PLS_ETR_JD_MODEL: "Please enter John Deere Model",
  PLS_ETR_REQ_FIELDS: "Please Enter Required Fields!",
  PLS_ETR_SALES_AMT: "Please enter Sales amount",
  RESULT_REASON: "Result Reason",
  RETRIEVE_TRAN_DET_MSG: "Retrieving Transaction Details",
  SAVE_TRANS_MSG: "Save Transaction",
  SELECT_CURRENCY: "Select Currency",
  SIGN_OUT_FUNC: "Sign Out",
  SIMULATE_FUNC: "Simulate",
  SIMULATE_USER_AS: "Simulated successfully as ",
  SPRD_MARGIN_PER_VALID_MSG:
    "Spread margin for transaction pricing must be within +/-40%",
  EXPORT_TRAN_WAITING_MSG: "This will take a couple seconds",
  TOTAL_TRANS: "Total Transactions",
  TRAN_QUOTE_DATE: "Transaction / Quote Date",
  TRAN_DATA_ENTRY: "Transaction Data Entry",
  TRANS_DEL_SUCCESS_MSG: "Transaction Deleted Successfully.",
  TRAN_DETAILS: "Transaction Details",
  TRAN_EXP_SUCCESSFULLY_MSG: "Transaction Exported Successfully.",
  TRAN_EXP_EMAIL_SUCCESSFULLY_MSG: "You will get Exported transactions report on your mail in sometime.",
  TRANS_PER_PAGE: "Transactions per page",
  TXN_WAIT_F0R_REVIEW_MSG_2: "Transactions Waiting for Review",
  DELETE_TRAN_MSG: "Delete Transaction",
  ONE_BID_WON_VALID_MSG: "Ensure one Bid should be WON",
  CNF_SUB_WITH_ALERTS_MSG: "Confirm / Submit with Alerts",
  COMPETITOR_INFO: "Competitor Information",
  TP_APP_TITLE: "Transaction Pricing",
  ENT_COMP_MODEL: "Please enter Competitor model",
  SRCH_BY: "Search By",
  GNRL_DTLS: "General Details",
  DEAL_DTLS: "Deal Details",
  EQUIP_DTLS: "Equipment Details",
  SALES_DTLS: "Sales Details",
  FIN_DTLS: "Financial Details",
  MODEL_AND_CATGRY: "Model & Categories",
  FRENCH_LANGUAGE: "French",
  ACTIONS: "Actions",
  TXN_SUCCESS_MSG: "Transaction Submitted Successfully!",
  PLZ_WAIT_TXN_MSG: "Please wait while we process your transaction",
  MACHINE_SPEC: "Machine Specification",
  OTHER_TECHNOLOGY: "Other Technology",
  ERR_SP_INCR: "Sales Person id is incorrect",
  ERR_SP_LEN: "Sales Person id must be 7 characters",
  ERR_SP_STARTX: "Sales Person id must be start with character 'X'",
  ERR_SAME_SP_DLSHP: "Please enter the Sales Person from same dealership",
  ERR_USR_INCR: "User id is incorrect",
  ERR_INVLD_SP: "Please Enter Valid Sales Person",
  ERR_SP_NAME_INVLD: "Sales Person Name not generated,Please try after some time",
  STARTS_WITH_PH: "Starts with...",
  CUST_NAME_VALIDATION : "Please enter a valid Customer Name",
  SPANISH_LANGUAGE: "Spanish",
  ATTACHMENT_UPLOAD_NOTE1:"Supported files: DOCX, PDF, XLSX, XLS. Max size: 10MB.",
  ATTACHMENT_UPLOAD_NOTE2 : "Attachments will be uploaded/deleted upon saving the Transaction.",
  ATTACHMENTS_NOTE: "NOTE:",
  DEL_ATTACH_MSG: "You are about to delete the following Attachment(s):",
  OVRT_ATTACH_MSG: "You are about to overwrite the following Attachment(s):",
  FILE_UPLD_SUC_MSG: "Files deleted successfully!",
  FILE_UPLD_FAIL_MSG: "Failed to delete attachments. Kindly try again after some time!"
};
